import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CabeceraVAMTitulares } from "./cabecera-vam-titulares.component";
import {FormsModule} from '@angular/forms';
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { TimerModule } from "../timer/timer.module";
import { CabeceraVamTitularService } from "./cabecera-vam-titulares.service";
import { ConsultarUsuarioVAM } from "../utils/consultarUsuarioVAM";



@NgModule({
    declarations: [CabeceraVAMTitulares],
    imports: [BrowserModule, RouterModule, FormsModule, TimerModule],
    exports:[CabeceraVAMTitulares],
    providers:[DatosGeneralesService, CabeceraVamTitularService, ConsultarUsuarioVAM]
})

export class CabeceraVAMModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraVAMTitulares/cabecera-vam-titulares.module.ts